import React, { memo, useEffect, useMemo, useState } from 'react'
import MultiSelect from './Multiselect'
import DropDownSkeleton from './DropDownSkeleton'
import { LoadListDefault, useGet } from '../../../api/hooks'
import { IsListNotEmpty } from '../../../utils'

const DropDown = ({ label, isAllowedToFetch = true, depArr = [], params = [], endPoint, defaultValue, formHandler, className = "col-md-6", isMulti = true, isDisabled = false, isRequired = true, isClearable = true }) => {

  const { formValues, handleFormValues } = formHandler

  const [sOptions, setSOptions] = useState(null)
  const [isDefaultValueLoaded, setIsDefaultValueLoaded] = useState(false)

  const paramsObject = useMemo(() => {
    let dataOfObject = []
    params.forEach((param, index) => {
      dataOfObject[index] = formValues[param]?.isMulti ?
        formValues[param]?.value.map(item => item.value) || [] : formValues[param]?.value?.value || ""
    })
    return dataOfObject
  }, [params, formValues ])

  console.log(paramsObject)

  const { result: options, isPending } = useGet({
    ...LoadListDefault,
    endPoint: endPoint,
    depArr: depArr,
    params: paramsObject,
    allowFetch:isAllowedToFetch,
    defaultValue: []
  })

  const handleChange = (sOptions) => {
    handleFormValues(label, { value: sOptions, isRequired, isError: false, isMulti })
    setSOptions(sOptions)
  }

  useEffect(() => {

    handleChange(isMulti ? [] : null)
  }, [])

  useEffect(() => {
    if (IsListNotEmpty(options) && !isDefaultValueLoaded) {
      if (defaultValue) {
        const dffValue = defaultValue || (isMulti ? [] : null)
        const selectedOptions = isMulti ? options?.filter(option => dffValue?.includes(option.value)) : options?.find(option => option.value === dffValue)
        handleChange(selectedOptions)
        setIsDefaultValueLoaded(true)
      }
    }

  }, [defaultValue, options])



  return (
    <>
      <DropDownSkeleton isRender={isPending} className={className} />

      <MultiSelect isError={formValues[label]?.isError} isRender={!isPending} label={label} sOptions={sOptions} setSOptions={handleChange} isRequired={isRequired}
        isClearable={isClearable} className={className} isMulti={isMulti} isDisabled={isDisabled} options={options} />
    </>

  )
}

export default memo(DropDown)